import './support/styleLoaderApp';
import './polyfill/all';
import './support/filterConsoleWarnings';

import React from 'react';
import ReactDOM from 'react-dom';

import { ThemeProvider } from './core-ui';
import { AppConfigProvider } from './AppConfig';
import { QueryProvider } from './api/QueryProvider';
import VendorPortalHome from './components/VendorPortalHome';
import DataStore from './support/DataStore';

const dataStore = DataStore.getInstance('app');
dataStore.set('entryPoint', 'vendor');

// Remove the main script tag before rendering.
let scripts = document.getElementsByTagName('script');
let script = scripts[scripts.length - 1];

let el = document.documentElement;
let marketName = document.title || '';
let marketAccountID = (el && el.getAttribute('data-market-account-id')) || '';

document.addEventListener('DOMContentLoaded', () => {
  if (script != null && script.parentNode != null) {
    script.parentNode.removeChild(script);
  }
  let container = document.querySelector('#app');
  if (container) {
    ReactDOM.render(
      <QueryProvider>
        <AppConfigProvider>
          <ThemeProvider>
            <VendorPortalHome
              marketName={marketName}
              marketAccountID={marketAccountID}
            />
          </ThemeProvider>
        </AppConfigProvider>
      </QueryProvider>,
      container,
    );
    let loadingIndicator = document.querySelector('.loading-indicator');
    if (loadingIndicator) {
      loadingIndicator.remove();
    }
  }
});
